import CheckCircleBlack from '@/images/CheckCircleBlack.svg';
import OneInCircle from '@/images/OneInCircle.svg';
import TwoInCircle from '@/images/TwoInCircle.svg';
import TwoInGrayCircle from '@/images/TwoInGrayCircle.svg';
import { Button } from '@de-id/ui-components';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { useFormContext } from 'react-hook-form';
import { useWebhookComponentContext } from '../contex';
import { WebhookFormValues } from '../types';

const DialogTabsContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-top: 24px;
`;

const StyledButton = styled(Button)<{ active?: boolean; readonly?: boolean }>`
    display: flex;
    align-items: center;
    gap: 8px;
    border-radius: 100px;

    ${({ active }) =>
        !active &&
        css`
            border: none !important;
        `}

    ${({ readonly }) =>
        readonly &&
        css`
            pointer-events: none;
        `}
`;

export const DialogTabs = () => {
    const { activeTab, setActiveTab } = useWebhookComponentContext();
    const {
        formState: { isValid },
    } = useFormContext<WebhookFormValues>();

    const configureActive = activeTab === 'configure';
    const testActive = activeTab === 'test';

    return (
        <DialogTabsContainer>
            <StyledButton color="outlined" size="small" active={configureActive} onClick={() => setActiveTab('configure')}>
                {configureActive ? <img src={OneInCircle} /> : <img src={CheckCircleBlack} />}
                Configure
            </StyledButton>
            <StyledButton color="outlined" size="small" active={testActive} readonly>
                {isValid ? <img src={TwoInCircle} /> : <img src={TwoInGrayCircle} />}
                Test
            </StyledButton>
        </DialogTabsContainer>
    );
};
